module.exports = __webpack_public_path__ + "static/media/annie-spratt-527637-unsplash.ab87b504.jpg";